import { useDispatch, useSelector } from 'react-redux';

import { useCallback } from 'react';
import useActionModal from '../../hooks/useActionModal';
import {
  setActionModalCancel,
  setActionModalConfirm,
  setReviewsModalOpen,
} from '../../redux/ducks/UIDucks';
import { ActionModalActionType } from '../../redux/ducks/UIDucks.types';
import type { RootReducerType } from '../../redux/reducers/RootReducer.types';
import Modal from './Modal';

const getEnumName = (value: ActionModalActionType): string => {
  switch (value) {
    case ActionModalActionType.BlockUser:
      return 'BlockUser';
    case ActionModalActionType.UnblockUser:
      return 'UnblockUser';
    case ActionModalActionType.ConfirmAppointment:
      return 'ConfirmAppointment';
    case ActionModalActionType.DenyAppointment:
      return 'DenyAppointment';
    case ActionModalActionType.CancelNewAppointment:
      return 'CancelNewAppointment';
    case ActionModalActionType.RequestCancelAppointment:
      return 'RequestCancelAppointment';
    case ActionModalActionType.AcceptCancelAppointment:
      return 'AcceptCancelAppointment';
    case ActionModalActionType.DenyCancelAppointment:
      return 'DenyCancelAppointment';
    case ActionModalActionType.AcceptChangeAppointment:
      return 'AcceptChangeAppointment';
    case ActionModalActionType.DenyChangeAppointment:
      return 'DenyChangeAppointment';
    case ActionModalActionType.CancelChangeAppointment:
      return 'CancelChangeAppointment';
    case ActionModalActionType.CancelCancelAppointment:
      return 'CancelCancelAppointment';
    case ActionModalActionType.DenyPushNotifications:
      return 'DenyPushNotifications';
    case ActionModalActionType.SendEmailToContact:
      return 'SendEmailToContact';
    case ActionModalActionType.CallContactOnPhone:
      return 'CallContactOnPhone';
    case ActionModalActionType.DeleteContact:
      return 'DeleteContact';
    case ActionModalActionType.DeleteBusiness:
      return 'DeleteBusiness';
    case ActionModalActionType.DeleteService:
      return 'DeleteService';
    case ActionModalActionType.DisableBusiness:
      return 'DisableBusiness';
    case ActionModalActionType.EnableBusiness:
      return 'EnableBusiness';
    case ActionModalActionType.DisableService:
      return 'DisableService';
    case ActionModalActionType.EnableService:
      return 'EnableService';
    case ActionModalActionType.ConfirmWhatsAppReminder:
      return 'ConfirmWhatsAppReminder';
    case ActionModalActionType.ConfirmSMSReminder:
      return 'ConfirmSMSReminder';
    case ActionModalActionType.AddContactPhoneNumber:
      return 'AddContactPhoneNumber';
    case ActionModalActionType.ConfirmWhatsAppConfirmation:
      return 'ConfirmWhatsAppConfirmation';
    case ActionModalActionType.ConfirmSMSConfirmation:
      return 'ConfirmSMSConfirmation';
    case ActionModalActionType.ConfirmDeleteTempHour:
      return 'ConfirmDeleteTempHour';
    case ActionModalActionType.ConfirmDeleteProfilePicture:
      return 'ConfirmDeleteProfilePicture';
    case ActionModalActionType.ConfirmAppointmentReportCreation:
      return 'ConfirmAppointmentReportCreation';
    case ActionModalActionType.ConfirmPublishProfile:
      return 'ConfirmPublishProfile';
    case ActionModalActionType.ConfirmUnpublishProfile:
      return 'ConfirmUnpublishProfile';
    default:
      return 'Unknown';
  }
};

const ActionModal = () => {
  const { isOpen } = useActionModal();
  const dispatch = useDispatch();

  const actionModalProps = useSelector(
    (state: RootReducerType) => state.ui.actionModalProps,
  );

  const bodyContent = (
    <div className="flex min-w-full flex-col gap-4">
      <span className="min-w-full py-2 text-center text-lg font-semibold">
        {actionModalProps?.message}
      </span>
    </div>
  );

  const onPrimary = useCallback(() => {
    if (isOpen) {
      dispatch(setActionModalConfirm(true));
    }
  }, [isOpen, dispatch]);

  const onSecondary = useCallback(() => {
    if (isOpen) {
      dispatch(setActionModalCancel(true));
    }
  }, [isOpen, dispatch]);

  return (
    <Modal
      id={`${getEnumName(
        actionModalProps?.action || ActionModalActionType.Unknown,
      )}_action_modal`}
      setIsOpen={(open) => dispatch(setReviewsModalOpen(open))}
      disabled={false}
      loading={false}
      isOpen={isOpen}
      title=""
      actionLabel={actionModalProps?.confirmLabel || ''}
      actionType={actionModalProps?.confirmLabelType}
      secondaryActionLabel={actionModalProps?.cancelLabel || ''}
      secondaryAction={onSecondary}
      onClose={onSecondary}
      onSubmit={onPrimary}
      body={bodyContent}
      noFit
      isAction
    />
  );
};

export default ActionModal;
